import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { useDispatch } from 'react-redux';
import PublicLayout from 'web/components/PublicLayout';
import StartPage from 'web/pages/public/landing-page/StartPage'
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const LandingPage = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        let token = localStorage.getItem('token')
        let isAdminOrUserAccount = localStorage.getItem('accountType')
        if (isAdminOrUserAccount && token) {
            if (isAdminOrUserAccount === 'Admin') history.push('/admin')
            else history.push('/dashboard')
        } else {
            dispatch(logoutAdmin())
            dispatch(logoutClearRedux())
            localStorage.clear()
            sessionStorage.clear()
        }
    }, [])

    return (
        <>
            <Helmet
                title="PalletTrader | Online Pallet Marketplace">
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/paymentfont/1.2.5/css/paymentfont.min.css" />
                <meta name="viewport" content="width=device-width initial-scale=1" />
                <meta
                    name="description"
                    content="PalletTrader is the online marketplace for buying and selling pallets. Streamline your pallet sourcing or sales with an easy-to-use platform built for your business."
                />
                <meta name="keywords"
                    content="PalletTrader, pallets, pallets for sale,wooden pallets,PalletTrader company, pallet companies,sell pallets,pallets company,buying pallets,selling pallets,pallet buyers,buy pallets online,pallet sellers,pallets online,buying pallets online,pallet supply,Pallet industry,pallet market,selling wood pallets,pallets supply,buying and selling pallets,buy wooden pallets online,wooden pallets online,pallet trader,selling pallets online,pallets market,sell pallets online,pallets marketplace,marketplace for pallets,wooden pallets at best price,digital pallet marketplace,Pallet Trader" />
                <meta name="robots" content="index,follow" />
                <meta name="msvalidate.01" content="C73FA5BD71427332163D025C5F1EC73E" />
                <link rel="canonical" href="https://www.pallettrader.com/" />
                <script type="application/ld+json">{
                    `{
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Pallets Supply, Reimagined | PalletTrader",
                        "url": "https://www.pallettrader.com/",
                        "logo": "https://www.pallettrader.com/static/media/NewHeaderLogo.7aa97e44.png",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "1-877-777-7495",
                            "contactType": "technical support",
                            "contactOption": "TollFree",
                            "areaServed": "US",
                            "availableLanguage": "en"
                        }
                    }`
                }
                </script>
                <script type="application/ld+json">{
                    `{
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        "name": "PalletTrader - Welcome to the World's First Online Marketplace for Buying & Selling Pallets",
                        "description": "Want to see what the ultimate 21st century digital pallet marketplace looks like?",
                        "thumbnailUrl": "https://yt3.ggpht.com/JXrRMf0jY_fCDs_JY2Rusp5pU3mACfMjFrb8JacpCZH6cjndCggVQW013BXN6EBhN4syy-Bf2g=s88-c-k-c0x00ffffff-no-rj",
                        "uploadDate": "2022-06-02",
                        "duration": "PT9M40S",
                        "contentUrl": "http://stage.pallettrader.com/#/",
                        "embedUrl": "https://youtu.be/9_0IGsi20ak"
                    }`
                }
                </script>
            </Helmet>
            <PublicLayout transparentHeader={true}>
                <StartPage />
            </PublicLayout>
        </>
    )
}

export default LandingPage;
